module.exports = ({
    "CDMS920LB001": "Protocol No.",
    "CDMS920LB002": "ชื่อสำรอง",
    "CDMS920LB003": "ชื่อการศึกษา",
    "CDMS920LB004": "จำนวนสถานวิจัย",
    "CDMS920LB005": "จำนวนผู้เข้าร่วมวิจัย",
    "CDMS920LB006": "การตั้งค่าระดับจำนวนสัญญา",
    "CDMS920TT001": "ข้อมูลทั่วไปของการศึกษา",
    "CDMS920OPT001": "ไม่มีข้อจำกัด",
    "CDMS920OPT002": "การศึกษา",
    "CDMS920OPT003": "สถานวิจัย"
});
